import { Component, OnInit } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';
import { KeycloakService } from 'keycloak-angular';
import { environment } from "../../../environments/environment";
import moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';

@Component({
  selector: 'app-mpost',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.scss'],
})
export class mPostComponent implements OnInit {

  userMetadata
  user$
  protected readonly environment = environment;
  post
  included = []
  slug
  private rawHttp: HttpClient;
  protected readonly moment = moment;

  constructor(private http: HttpClient, private data: DataService, public keycloak: KeycloakService, private httpBackend: HttpBackend, private _route: ActivatedRoute) { }

  async ngOnInit() {
    this.user$ = await this.keycloak.loadUserProfile();
    this.userMetadata = await this.data.getFromStorage("userMetadata")
    this.rawHttp = new HttpClient(this.httpBackend);
    this.slug=await this._route.snapshot.params['id']
    this.getDiscussions()
  }

  async getDiscussions() {
    await this.rawHttp
      .get(
        '/api/forum-proxy/discussions/'+this.slug,
        {
          headers: {
            'Content-Type': 'application/json',
            //"Authorization": "Token 1c67499c-1af8-4531-a9c0-204ad2100f80; userId=" + this.userMetadata.forumid, //; userId=2
            "kieg": this.userMetadata.forumid ? "; userId=" + this.userMetadata.forumid : ""
          }
        }
      )
      .subscribe({
        next: (response: any) => {
          this.post = response.data
          this.included = response.included
          //console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  }

}
